"use strict"
exports.__esModule = true;
exports.ChartAreaIconConfig = {
  name: 'ChartAreaIcon',
  height: 512,
  width: 512,
  svgPath: 'M500 384c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v308h436zM372.7 159.5L288 216l-85.3-113.7c-5.1-6.8-15.5-6.3-19.9 1L96 248v104h384l-89.9-187.8c-3.2-6.5-11.4-8.7-17.4-4.7z',
  yOffset: 0,
  xOffset: 0,
};
exports.ChartAreaIcon = require('../createIcon').createIcon(exports.ChartAreaIconConfig);
exports["default"] = exports.ChartAreaIcon;